/**
 * Umožní ovládání prvků pomocí klávesnice.
 * Poslouchá Enter/mezerník.
 * https://coweo.myjetbrains.com/youtrack/issue/JP-6379/EAA-audit-pristupnost-webu
 */
export default function roleButtonKeyboardControl(el) {
	// Přidání keydown eventu jen jednou
	if (!el.dataset.keyboardControlBound) {
		el.addEventListener('keydown', (event) => {
			const targetTag = event.target.tagName.toLowerCase();

			// Pokud event přišel z nativního inputu/textarea/select, ignorujeme
			if (['input', 'textarea', 'select', 'button'].includes(targetTag)) {
				return;
			}

			// Pokud zmáčkne uživatel na prvku enter nebo mezerník vyvoláme click
			if (event.key === 'Enter' || event.key === ' ') {
				el.click();
				event.preventDefault();
			}
		});
		el.dataset.keyboardControlBound = 'true';
	}

	// Zabránit kliknutí rodiče při ovládání klávesami na vnořených inputech (checkbox/radio)
	const inputs = el.querySelectorAll('input[type="checkbox"], input[type="radio"]');
	inputs.forEach((input) => {
		if (!input.dataset.keyboardControlBound) {
			input.addEventListener('keydown', (event) => {
				if (event.key === ' ' || event.key === 'Enter') {
					event.stopPropagation(); // zabrání eventu dojít k rodiči a spustit jeho click
				}
			});
			input.dataset.keyboardControlBound = 'true';
		}
	});
}
